module.exports = __webpack_public_path__ + "static/starsmix-image-d3ca30dab9096ec0a810df6ff36e8ba7.png";